package one.healthium.events

import one.healthium.domain.user.UserEvents
import one.healthium.tasks.domain.TasksCompletionEventsHandler

internal class UserEventsImpl(
    tasksHandler: TasksCompletionEventsHandler,
    userEventsChannel: UserEventsChannel,
) : UserEvents {

    private val handlers = listOf(
        tasksHandler,
        userEventsChannel,
    )

    override suspend fun onWaterIntakeAdded(taskId: String?) {
        handlers.forEach { it.onWaterIntakeAdded(taskId) }
    }

    override suspend fun onWeightUpdated(taskId: String?) {
        handlers.forEach { it.onWeightUpdated(taskId) }
    }

    override suspend fun onFoodAdded(taskId: String?) {
        handlers.forEach { it.onFoodAdded(taskId) }
    }

    override suspend fun onSymptomsAdded(taskId: String?) {
        handlers.forEach { it.onSymptomsAdded(taskId) }
    }

    override suspend fun onHealthLogAdded(taskId: String?) {
        handlers.forEach { it.onHealthLogAdded(taskId) }
    }
}